'use client';

import React from 'react';

import ContentCategoryCard from '@/components/design/contentCategoryCard';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import { Skeleton } from '@/components/ui/skeleton';
import useContentBankCategories from '@/hooks/queries/useContentBankCategories';
import { cn } from '@/lib/utils';
import routes from '@/statics/routes';
import recursiveFindParents from '@/utils/recursiveFindParents';

type Props = {
  className?: string;
};

const LandingContentBankCarousel: React.FC<Props> = () => {
  const { data, isFetched } = useContentBankCategories();

  const contents = data || [null, null, null, null];

  if (isFetched && !data) {
    return null;
  }

  return (
    <div>
      <Carousel
        opts={{
          align: 'start',
          direction: 'rtl',
          loop: false,
          dragFree: true,
        }}
      >
        <CarouselContent>
          {data
            ? data
                .filter((item) => (item ? item?.parent_id === null : item))
                .map((category, index) => (
                  <CarouselItem
                    className={cn(
                      'flex-[0_0_30%]',
                      index === 0 && 'ms-5',
                      index === contents.length - 1 && 'me-5'
                    )}
                    key={category ? category.id : index}
                  >
                    {category ? (
                      <ContentCategoryCard
                        key={category.id}
                        content={category}
                        link={
                          data.findIndex(
                            (item) => item?.parent_id === category.id
                          ) === -1
                            ? routes.contentBankCategory.href(category.id)
                            : routes.contentBankSubCategory.href([
                                ...recursiveFindParents(category, data).map(
                                  ({ id }) => id
                                ),
                                category.id,
                              ])
                        }
                      />
                    ) : (
                      <Skeleton className="w-full aspect-[53/50] rounded-2xl" />
                    )}
                  </CarouselItem>
                ))
            : null}
        </CarouselContent>
      </Carousel>
    </div>
  );
};

export default LandingContentBankCarousel;
